module.exports = __webpack_public_path__ + "8276505c1c31e67cf4d17e79adb842f1.fbx";